import { Alert, AlertTitle, Box, Typography } from '@mui/material';
import { useTranslate } from 'react-admin';

import { GetEmployeeLockedFundsResponse } from '@Common/types/bo/b2b/employees/locked_funds';

import { formatCentsNumber } from '@sh4res/bo-common/utils';

type SuspendedFundsNoticeProps = {
  lockedFunds: GetEmployeeLockedFundsResponse;
  testId: string;
};

export const SuspendedFundsNotice = ({ lockedFunds, testId }: SuspendedFundsNoticeProps) => {
  const translate = useTranslate();

  return (
    <Alert severity="warning" data-testid={`${testId}_SuspendedFundsNotice`}>
      <AlertTitle>
        {translate('resources.bo_common.b2b.withdrawals.create.suspended.title', {
          total: formatCentsNumber(lockedFunds.suspended),
        })}
      </AlertTitle>
      <Typography variant="body2" sx={{ mb: 1 }}>
        {translate('resources.bo_common.b2b.withdrawals.create.suspended.description')}
      </Typography>
      {lockedFunds.suspended_positions.map((position) => (
        <Box
          key={position.instrument_id}
          sx={{ display: 'flex', justifyContent: 'space-between', gap: 2 }}>
          <Typography variant="body2">{position.short_name ?? position.symbol}</Typography>
          <Typography variant="body2">{formatCentsNumber(position.amount)}</Typography>
        </Box>
      ))}
    </Alert>
  );
};
